const AllLandingPages  = [
    {
        name: "Microsoft Login",
        landingPagePath: 'https://d35p3si8xgkjxu.cloudfront.net/assets/img/landingpage/Two%20Stage%20Landing%20Page//tmp/TempStorage/Two%20Stage%20Landing%20Page/Two%20Stage%20Landing%20Page/index.html',
    },
    {
        name: "Google Login",
        landingPagePath: "/landing-page/default",
    },
]

export default AllLandingPages;